import { InquiryStateTypes } from './../../interfaces';

export const state: InquiryStateTypes = {
    inquiryNewStoreParam: undefined,
};
